import React, { useEffect, useRef, useState } from "react";
import "./landing.css";

export default function Clients({
  logos = [
    // replace with your 8 logos
    "https://supersteno.com/assetsa/img/clients/client-1.png",
    "https://supersteno.com/assetsa/img/clients/client-2.png",
    "https://supersteno.com/assetsa/img/clients/client-3.png",
    "https://supersteno.com/assetsa/img/clients/client-4.png",
    "https://supersteno.com/assetsa/img/clients/client-5.png",
    "https://supersteno.com/assetsa/img/clients/client-6.png",
    "https://supersteno.com/assetsa/img/clients/client-7.png",
    "https://supersteno.com/assetsa/img/clients/client-8.png",
  ],
  autoplayDelay = 1700,
}) {
  const base = logos;
  const slides = [...base, ...base]; // duplicate for seamless loop
  const total = base.length;

  const [index, setIndex] = useState(0); // number of steps moved
  const [transitionEnabled, setTransitionEnabled] = useState(true);
  const [perView, setPerView] = useState(6);
  const hoverRef = useRef(false);
  const timerRef = useRef(null);

  // responsive perView
  useEffect(() => {
    function calc() {
      const w = window.innerWidth;
      if (w >= 1200) setPerView(6);
      else if (w >= 992) setPerView(5);
      else if (w >= 768) setPerView(4);
      else if (w >= 480) setPerView(3);
      else setPerView(2);
    }
    calc();
    window.addEventListener("resize", calc);
    return () => window.removeEventListener("resize", calc);
  }, []);

  // autoplay
  useEffect(() => {
    start();
    return stop;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [perView]);

  function start() {
    stop();
    timerRef.current = setInterval(() => {
      if (hoverRef.current) return;
      setIndex((p) => p + 1);
    }, autoplayDelay);
  }
  function stop() {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  }

  // when index enters duplicated block, snap back to base block w/o transition
  useEffect(() => {
    if (index >= total) {
      const t = setTimeout(() => {
        setTransitionEnabled(false);
        setIndex((prev) => prev - total);
        requestAnimationFrame(() => requestAnimationFrame(() => setTransitionEnabled(true)));
      }, 320);
      return () => clearTimeout(t);
    }
    return undefined;
  }, [index, total]);

  // compute slide width percentage based on perView
  const slidePercent = 100 / perView;
  // transform: move by index * slidePercent
  const translate = -(index * slidePercent);

  function onEnter() { hoverRef.current = true; }
  function onLeave() { hoverRef.current = false; }

  // jump to dot (show that logo at first position)
  function goToDot(i) {
    setIndex(i);
  }

  // normalized index (0..total-1)
  const normalized = index % total;

  return (
    <section className="cc-section">
      <div className="cc-container">
        <h2 className="cc-title">Clients</h2>
        <span className="cc-underline" />
        <p className="cc-desc">Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit. Quisquam quos quisquam cupiditate. Et nemo qui impedit suscipit alias ea. Quia fugiat sit in iste officiis commodi quidem hic quas</p>

        <div className="cc-viewport" onMouseEnter={onEnter} onMouseLeave={onLeave}>
          <div
            className="cc-track"
            style={{
              transform: `translateX(${translate}%)`,
              transition: transitionEnabled ? "transform 320ms ease" : "none",
            }}
          >
            {slides.map((src, i) => (
              <div
                key={i}
                className="cc-slide"
                style={{ flex: `0 0 ${slidePercent}%` }} /* crucial: width depends on perView */
              >
                <figure className="cc-logoBox">
                  <img className="cc-logoImg" src={src} alt={`Client ${i % total + 1}`} />
                </figure>
              </div>
            ))}
          </div>
        </div>

        <div className="cc-dots">
          {Array.from({ length: total }).map((_, i) => (
            <button
              key={i}
              className={`cc-dot ${normalized === i ? "active" : ""}`}
              onClick={() => goToDot(i)}
              aria-label={`Go to ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
